import React, { useState, useEffect } from 'react';
import axiosInstance from "../../api/axiosInstance";
import { toast } from 'react-toastify';
import Editor from '@monaco-editor/react';

const CssEditorPage = () => {
  const fixedSheetName = 'LandingPage';
  const [cssContent, setCssContent] = useState('');
  const [lastModified, setLastModified] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);

  // Fetch the LandingPage CSS
  useEffect(() => {
    const fetchCss = async () => {
      try {
        const response = await axiosInstance.get(`/styles/${fixedSheetName}`);
        setCssContent(response.data.cssContent);
        setLastModified(new Date().toLocaleString());
      } catch (error) {
        toast.error('Failed to load LandingPage CSS');
        console.error('Fetch error:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCss();
  }, []);

  // Save updated CSS
  const handleSave = async () => {
    setIsSaving(true);
    const yourToken = localStorage.getItem('token');

    try {
      await axiosInstance.put(`/styles/${fixedSheetName}`, cssContent, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${yourToken}`
        }
      });

      toast.success('Changes saved!');
      setLastModified(new Date().toLocaleString());
    } catch (error) {
      toast.error('Failed to save CSS');
      console.error('Save error:', error);
    } finally {
      setIsSaving(false);
    }
  };

  if (isLoading) {
    return <div className="container py-4">Loading LandingPage CSS...</div>;
  }

  return (
    <div className="container py-4">
      <h1>Landing Page CSS Editor</h1>
      <p className="text-muted">Last updated: {lastModified}</p>

      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h5 className="mb-0">{fixedSheetName}.css</h5>
          <button
            className="btn btn-success"
            onClick={handleSave}
            disabled={isSaving}
          >
            {isSaving ? 'Saving...' : 'Save Changes'}
          </button>
        </div>
        <div className="card-body p-0">
          <Editor
            height="500px"
            defaultLanguage="css"
            value={cssContent}
            onChange={(value) => setCssContent(value || '')}
            theme="vs-dark"
            options={{
              fontSize: 14,
              wordWrap: 'on',
              minimap: { enabled: false }
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default CssEditorPage;
